// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'

import axios from 'axios'
import VueAxios from 'vue-axios'
import VueAuth from '@websanova/vue-auth'
import VueAuthUtils from '@websanova/vue-auth/src/lib/utils.js'
import VueToastr from '@deveodk/vue-toastr'
import lodash from 'lodash'
import VueLodash from 'vue-lodash'
import VeeValidate, {
  Validator
} from 'vee-validate'
import datePicker from 'vue-bootstrap-datetimepicker'
import messages from 'vee-validate/dist/locale/pt_PT.js'
import kendo from '@progress/kendo-ui/js/kendo.all.js' // eslint-disable-line no-unused-vars
import '@progress/kendo-ui/js/cultures/kendo.culture.pt-PT.js' // eslint-disable-line no-unused-vars
import '@progress/kendo-ui/js/messages/kendo.messages.pt-PT.js' // eslint-disable-line no-unused-vars
import yourMoment from 'moment'
import VueScrollTo from 'vue-scrollto'
import VueCurrencyFilter from 'vue-currency-filter'
import VueMask from 'v-mask'
import Bearer from './auth/bearer.js'
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css'
import ModalSelect from '@/components/ModalSelect.vue'
import GridFilters from '@/components/GridFilters.vue'
import Exporter from '@/components/Exporter'

// todo
kendo.culture('pt-PT')
Window.prototype.$ = kendo.jQuery

function percent(a, b) {
  if (b === 0) {
    return 0
  }
  return Math.round(a / b * 10000) / 100
}
Window.prototype.percent = percent

function growth(a, b) {
  if (b === 0) {
    return 0
  }
  return Math.round((a - b) / b * 10000) / 100
}
Window.prototype.growth = growth

function growthFormat(p) {
  var icon = '<i class="fa fa-minus"></i>'
  if (p > 0) {
    icon = '<i class="fa fa-arrow-up text-success"></i>'
  } else if (p < 0) {
    icon = '<i class="fa fa-arrow-down text-danger"></i>'
  } else {
    icon = '<i class="fa fa-equals text-secondary"></i>'
  }
  return kendo.toString(p, 'n1') + '% ' + icon
}
Window.prototype.growthFormat = growthFormat

yourMoment.locale('pt')
Vue.prototype.$moment = yourMoment

Vue.router = router
Vue.use(BootstrapVue)
Vue.use(VueToastr, {
  defaultPosition: 'toast-top-center',
  defaultType: 'info',
  defaultTimeout: 1000
})
Vue.use(VueCurrencyFilter, {
  symbol: '€',
  thousandsSeparator: '.',
  fractionCount: 2,
  fractionSeparator: ',',
  symbolPosition: 'back',
  symbolSpacing: true
})
console.log(process.env.VUE_APP_SECRET)

var apiRoot = process.env.VUE_APP_API
console.log(apiRoot)
if (typeof Window.appConfig !== 'undefined' && Window.appConfig.baseUrl !== 'undefined') {
  apiRoot = Window.appConfig.baseUrl
}
Vue.prototype.APIURL = apiRoot
axios.defaults.baseURL = apiRoot
// axios.defaults.withCredentials = true
// axios.defaults.preflightContinue = true
Vue.use(VueAxios, axios)
Object.defineProperty(Vue.prototype, '$lodash', {
  value: lodash
})
Vue.use(VueScrollTo)
Vue.use(VueLodash, lodash)
Vue.use(datePicker)
Vue.use(VueMask)
Vue.component('modal-select', ModalSelect)
Vue.component('grid-filters', GridFilters)
Vue.component('exporter', Exporter)

const isUniqueUsername = (value, args) => {
  return Vue.axios.post('users/username', {
    username: value,
    user_id: args[0]
  }).then((response) => {
    // Notice that we return an object containing both a valid property and a data property.
    return {
      valid: response.data.valid,
      data: {
        message: response.data.message
      }
    }
  })
}
const isUniqueEmail = (value, args) => {
  return Vue.axios.post('users/email', {
    email: value,
    user_id: args[0]
  }).then((response) => {
    // Notice that we return an object containing both a valid property and a data property.
    return {
      valid: response.data.valid,
      data: {
        message: response.data.message
      }
    }
  })
}

Vue.use(VeeValidate, {
  locale: 'pt_PT',
  inject: true,
  fieldsBagName: 'veeFields'
})
messages.attributes = {
  email: 'Email',
  name: 'Nome',
  username: 'Nome de utilizador',
  password: 'Palavra-passe',
  password_confirm: 'Confirme a palavra-passe'
}
Validator.localize('pt_PT', messages)
// The messages getter may also accept a third parameter that includes the data we returned earlier.
Validator.extend('username', {
  validate: isUniqueUsername,
  getMessage: (field, params, data) => {
    console.log(data)
    return data.message
  }
})
Validator.extend('uniqueemail', {
  validate: isUniqueEmail,
  getMessage: (field, params, data) => {
    console.log(data)
    return data.message
  }
})

Vue.use(VueAuth, {
  auth: Bearer,
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  authRedirect: {
    path: '/login'
  },
  fetchData: {
    url: 'users/me'
  },
  refreshData: {
    url: 'auth/refresh'
  },
  // rolesVar: 'permissions'
  check: function(role) {
    if (this.watch.authenticated === true) {
      if (role) {
        if (VueAuthUtils.compare('superuser', this.watch.data['permissions'])) {
          return true
        }
        // if (VueAuthUtils.compare('dashboard.accounts', this.watch.data['permissions'])) {
        //  return true
        // }
        // Comentado Edgar Meira a 28/01 para fazer layout
        return VueAuthUtils.compare(role, this.watch.data['roles']) || VueAuthUtils.compare(role, this.watch.data['permissions'])
      }
      return true
    }
    return false
  }
})
Vue.auth.perms = function(perm) {
  return this.options.check.call(this, perm, 'permissions')
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  }
})
